import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _27db8081 = () => interopDefault(import('../pages/About.vue' /* webpackChunkName: "pages/About" */))
const _704b4b04 = () => interopDefault(import('../pages/Agreement.vue' /* webpackChunkName: "pages/Agreement" */))
const _0e39f9ab = () => interopDefault(import('../pages/Banks.vue' /* webpackChunkName: "pages/Banks" */))
const _c071a778 = () => interopDefault(import('../pages/Buyout.vue' /* webpackChunkName: "pages/Buyout" */))
const _bd0b8ed8 = () => interopDefault(import('../pages/Contact.vue' /* webpackChunkName: "pages/Contact" */))
const _22c3cda0 = () => interopDefault(import('../pages/Cookie.vue' /* webpackChunkName: "pages/Cookie" */))
const _973d7310 = () => interopDefault(import('../pages/Credit/index.vue' /* webpackChunkName: "pages/Credit/index" */))
const _cd0d7e42 = () => interopDefault(import('../pages/Exchange.vue' /* webpackChunkName: "pages/Exchange" */))
const _12b9844b = () => interopDefault(import('../pages/Favorites.vue' /* webpackChunkName: "pages/Favorites" */))
const _42adce9c = () => interopDefault(import('../pages/Podbor.vue' /* webpackChunkName: "pages/Podbor" */))
const _0eb37808 = () => interopDefault(import('../pages/Privacy.vue' /* webpackChunkName: "pages/Privacy" */))
const _3ebad983 = () => interopDefault(import('../pages/Rassrochka.vue' /* webpackChunkName: "pages/Rassrochka" */))
const _1db6d9e2 = () => interopDefault(import('../pages/Reviews.vue' /* webpackChunkName: "pages/Reviews" */))
const _42567f85 = () => interopDefault(import('../pages/Thanks.vue' /* webpackChunkName: "pages/Thanks" */))
const _5fbd8934 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _66a3bbf8 = () => interopDefault(import('../pages/Credit/_bank/index.vue' /* webpackChunkName: "pages/Credit/_bank/index" */))
const _092b5998 = () => interopDefault(import('../pages/_category/index.vue' /* webpackChunkName: "pages/_category/index" */))
const _601ff111 = () => interopDefault(import('../pages/_category/_mark/index.vue' /* webpackChunkName: "pages/_category/_mark/index" */))
const _5a2ed03e = () => interopDefault(import('../pages/_category/_mark/_model/index.vue' /* webpackChunkName: "pages/_category/_mark/_model/index" */))
const _59cf569c = () => interopDefault(import('../pages/_category/_mark/_model/_car/index.vue' /* webpackChunkName: "pages/_category/_mark/_model/_car/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/About",
    component: _27db8081,
    name: "About"
  }, {
    path: "/Agreement",
    component: _704b4b04,
    name: "Agreement"
  }, {
    path: "/Banks",
    component: _0e39f9ab,
    name: "Banks"
  }, {
    path: "/Buyout",
    component: _c071a778,
    name: "Buyout"
  }, {
    path: "/Contact",
    component: _bd0b8ed8,
    name: "Contact"
  }, {
    path: "/Cookie",
    component: _22c3cda0,
    name: "Cookie"
  }, {
    path: "/Credit",
    component: _973d7310,
    name: "Credit"
  }, {
    path: "/Exchange",
    component: _cd0d7e42,
    name: "Exchange"
  }, {
    path: "/Favorites",
    component: _12b9844b,
    name: "Favorites"
  }, {
    path: "/Podbor",
    component: _42adce9c,
    name: "Podbor"
  }, {
    path: "/Privacy",
    component: _0eb37808,
    name: "Privacy"
  }, {
    path: "/Rassrochka",
    component: _3ebad983,
    name: "Rassrochka"
  }, {
    path: "/Reviews",
    component: _1db6d9e2,
    name: "Reviews"
  }, {
    path: "/Thanks",
    component: _42567f85,
    name: "Thanks"
  }, {
    path: "/",
    component: _5fbd8934,
    name: "index"
  }, {
    path: "/Credit/:bank",
    component: _66a3bbf8,
    name: "Credit-bank"
  }, {
    path: "/:category",
    component: _092b5998,
    name: "category"
  }, {
    path: "/:category/:mark",
    component: _601ff111,
    name: "category-mark"
  }, {
    path: "/:category/:mark/:model",
    component: _5a2ed03e,
    name: "category-mark-model"
  }, {
    path: "/:category/:mark/:model/:car",
    component: _59cf569c,
    name: "category-mark-model-car"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
